import { SuperAdminService } from "services/superAdminService";

class RamadanDiarySAService extends SuperAdminService<any> {
  constructor() {
    super("ramadan-diary");
  }
}
export default new RamadanDiarySAService();
